import React from "react";
import { IPropertyDetailsContent, ContentType } from "../interfaces/property";
import Markdown from "react-markdown";

function createRandomString(length) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function instanceOfPropertyDetailsContent(
  object: unknown,
): object is IPropertyDetailsContent {
  return (
    typeof object === "object" &&
    object !== null &&
    "header" in object &&
    "content" in object
  );
}

export function getContent(
  contentType: ContentType = ContentType.BUTTON,
  props:
    | string
    | string[]
    | IPropertyDetailsContent
    | IPropertyDetailsContent[],
): React.ReactNode {
  if (typeof props === "object") {
    if (instanceOfPropertyDetailsContent(props)) {
      if (Array.isArray(props.content)) {
        return (
          <ul className="mt-[16px] md:mt-[22px]">
            {props.content.map((content, index) => (
              <li key={createRandomString(index + 1)}>{String(content)}</li>
            ))}
          </ul>
        );
      }

      return (
        <p
          className={
            "mt-[16px] md:mt-[22px]" + (props.header ? " font-bold" : "")
          }
          key={createRandomString(10)}
        >
          {props.type && props.type === "link" ? (
            <a href={props.link} target="_blank">
              {String(props.content)}
            </a>
          ) : (
            String(props.content)
          )}
        </p>
      );

      // ----- Property Description -----
    } else if (
      Array.isArray(props) &&
      props.length > 0 &&
      instanceOfPropertyDetailsContent(props[0])
    ) {
      return (props as IPropertyDetailsContent[]).map(
        (c: IPropertyDetailsContent, i: number) => {
          if (Array.isArray(c.content)) {
            return (
              <ul
                className="mt-[16px] md:mt-[22px]"
                key={createRandomString(i + 1)}
              >
                {c.content.map((content, index) => {
                  return (
                    <li
                      className={c.header ? " font-bold" : ""}
                      key={createRandomString(index + 1)}
                    >
                      {String(content)}
                    </li>
                  );
                })}
              </ul>
            );
          }

          return (
            <p
              className={
                "mt-[16px] md:mt-[22px]" + (c.header ? " font-bold" : "")
              }
              key={i + 1}
            >
              {c.type && c.type === "link" ? (
                <a href={c.link} target="_blank">
                  {String(c.content)}
                </a>
              ) : (
                String(c.content)
              )}
            </p>
          );
        },
      );
    } else if (
      Array.isArray(props) &&
      props.length > 0 &&
      typeof props[0] === "string"
    ) {
      const li = props.map((content, index) => (
        <li key={createRandomString(index + 1)}>{String(content)}</li>
      ));

      return <ul className="mt-[16px] md:mt-[22px]">{li}</ul>;

      // ----- ?? -----
    } else {
      // Fallback for unexpected object types
      console.warn("Unexpected object type passed to getContent:", props);
      return (
        <p
          className={
            contentType === ContentType.FAQ ? "" : "mt-[16px] md:mt-[22px]"
          }
        >
          {String(props)}
        </p>
      );
    }

    // ----- FAQs & Overlay paragraphs -----
  } else {
    function UL(props) {
      return (
        <ul className="mt-[16px] md:mt-[22px]" {...props}>
          {props.children}
        </ul>
      );
    }

    function P(props) {
      return (
        <p
          className={
            contentType === ContentType.FAQ ? "" : "mt-[16px] md:mt-[22px]"
          }
          {...props}
        />
      );
    }

    return <Markdown components={{ p: P, ul: UL }}>{props}</Markdown>;
  }
}
